import type { CalculatorMeta } from "../../types/calculator";

const meta: CalculatorMeta = {
  route: "/ideal-gas-law-calculator",
  component: () => import("../../routes/IdealGasLawCalculator.svelte"),
  card: {
    id: "ideal-gas-law-calculator",
    title: "Ideal Gas Law Calculator",
    description:
      "Solve the ideal gas law PV = nRT for any variable. Convert between Pa, atm, bar, psi, mmHg, torr; liters, mL, m³, ft³; Kelvin, Celsius, Fahrenheit, Rankine. Includes gas presets (N₂, O₂, H₂, He, CO₂, air) with density.",
    icon: "science",
    iconBgClass: "bg-cyan-50",
    iconTextClass: "text-cyan-600",
    href: "/ideal-gas-law-calculator",
    category: "Physics & Science",
  },
  seo: {
    title: "Ideal Gas Law Calculator – PV = nRT Solver",
    description:
      "Free ideal gas law calculator using PV = nRT. Solve for pressure, volume, moles, or temperature. Supports Pa, kPa, atm, bar, psi, mmHg, torr; L, mL, m³, ft³; K, °C, °F, °R. Includes gas presets with molar mass and density.",
  },
};

export default meta;